var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BAC59DA0-22B5-4DA7-B4C9-AEED276CF374") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "23.553719%",
    x2: "0%",
    y2: "76.446281%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26ECB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FCC93",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-P6-L-checks",
    transform: "translate(-764.000000, -2034.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unselected",
    transform: "translate(735.000000, 2003.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "icon-checkmark",
    points: "30.8731655 33.6496764 33.2902948 35.8786408 38.5851678 31 40.4583333 32.7273463 35.1678471 37.6059871 33.2902948 39.3333333 31.4171293 37.6059871 29 35.3770227"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkGreen);
export default __webpack_public_path__ + "static/media/icon-checkmark-green.3bb9131cf13aa1f796299fc050625820.svg";
export { ForwardRef as ReactComponent };